import { useMutation, useQueryClient } from '@tanstack/react-query'
import { apiClient } from '@/api/http/client'
import { queryKeys } from '@/api/query-keys'
import { SP_NOTIFICATIONS_API_BASE } from '../lib/notifications-api-paths'

const MONGO_OBJECT_ID_HEX24 = /^[a-fA-F0-9]{24}$/

function isValidMongoObjectIdString(id: string): boolean {
  return MONGO_OBJECT_ID_HEX24.test(id.trim())
}

export function useMarkNotificationRead() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: async (notificationId: string) => {
      const id = notificationId.trim()
      if (!isValidMongoObjectIdString(id)) return
      await apiClient.patch(`${SP_NOTIFICATIONS_API_BASE}/${id}/read`)
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: queryKeys.spNotifications.all() })
    },
  })
}

export function useMarkAllNotificationsRead() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: async () => {
      await apiClient.patch(`${SP_NOTIFICATIONS_API_BASE}/read-all`)
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: queryKeys.spNotifications.all() })
    },
  })
}

export function useClearReadNotifications() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: async () => {
      await apiClient.delete(`${SP_NOTIFICATIONS_API_BASE}/read`)
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: queryKeys.spNotifications.all() })
    },
  })
}
